import { IToastState } from '~src/store/toast/types';
import { IStudioState } from '~src/store/types';

const getToastState = (state: IStudioState): IToastState => {
    return state.toast;
};

export { getToastState };
